import { Column } from '../Layout/Column';
import { Row } from '../Layout/Row';

import React, { Component, PropsWithChildren } from 'react';
import { IEqualColumnSizes, ILayoutGridProps } from './types';

/**
 * Wraps a collection of form inputs to generate a bootstrap layout with evenly-spaced columns
 */
export class LayoutGrid extends Component<PropsWithChildren<ILayoutGridProps>, { layoutGrid: React.ReactNode[] }> {
  public generateEqualColumnComponentSizes = () => {
    switch (this.props.numberOfColumns) {
      case 2:
        return { lg: 6, md: 6, sm: 6, xs: 12 };
      case 3:
        return { lg: 4, md: 4, sm: 4, xs: 12 };
      case 4:
        return { lg: 3, md: 3, sm: 3, xs: 12 };
      case 5:
        return { lg: 2, md: 2, sm: 2, xs: 12 };
      case 6:
        return { lg: 2, md: 2, sm: 2, xs: 12 };
      default:
        return { lg: 12, md: 12, sm: 12, xs: 12 };
    }
  };

  public drawLayoutGrid = () => {
    const { children, numberOfColumns } = this.props;

    const layoutGrid: React.ReactNode[] = [];
    let columnCounter: number = 0;
    let rowGroup: React.ReactNode[] = [];
    let rowNumber: number = 0;

    // Constrains each column to a maxWidth
    const maxWidthStyles: { maxWidth?: string } = this.props.disableMaxWidth ? {} : { maxWidth: '700px' };

    const columnSizes: IEqualColumnSizes = this.generateEqualColumnComponentSizes();

    React.Children.forEach(this.props.children, (childElement, index) => {
      if (columnCounter < numberOfColumns) {
        columnCounter++;
        rowGroup.push(
          <Column size={columnSizes} key={index}>
            <div style={maxWidthStyles}>{childElement}</div>
          </Column>,
        );
      }

      // We've reached the column limit or ran out of components;
      // place inside a Row component.
      if (columnCounter === numberOfColumns || !children[index + 1]) {
        layoutGrid.push(
          <Row section={this.props.renderRowsAsSections} key={rowNumber++}>
            {rowGroup}
          </Row>,
        );
        columnCounter = 0;
        rowGroup = [];
      }
    });

    return layoutGrid;
  };

  public render() {
    return <div className="layout-grid">{this.drawLayoutGrid()}</div>;
  }
}

export default LayoutGrid;
